import {
  ON_START_GET_MAIL,
  ON_ERROR_GET_MAIL,
  ON_GET_MAIL,ON_GET_GMAIL,
  ON_START_GET_MAIL_LIST,
  ON_ERROR_GET_MAIL_LIST,
  ON_GET_MAIL_LIST,ON_GET_GMAIL_LIST,
  ON_START_GET_MAIL_FOLDERS,
  ON_ERROR_GET_MAIL_FOLDERS,
  ON_GET_MAIL_FOLDERS,ON_GET_GMAIL_FOLDERS,
  ON_START_SEND_MAIL_AS_NEW,
  ON_ERROR_SEND_MAIL_AS_NEW,
  ON_SEND_MAIL_AS_NEW,ON_SEND_GMAIL_AS_NEW,
  ON_START_ATTACH_MAIL_TO_KUND,
  ON_ERROR_ATTACH_MAIL_TO_KUND,
  ON_ATTACH_MAIL_TO_KUND,ON_ATTACH_GMAIL_TO_KUND,
  ON_START_DELETE_MAILS,ON_DELETE_DRAFT_GMAILS,
  ON_ERROR_DELETE_MAILS,
  ON_DELETE_MAILS,
  ON_START_MOVE_MAILS,
  ON_ERROR_MOVE_MAILS,
  ON_MOVE_MAILS,
  ON_START_SAVE_MAIL,
  ON_ERROR_SAVE_MAIL,
  ON_GET_SAVE_MAIL,ON_GET_SAVE_GMAIL,
  ON_START_CREATE_REPLY_MAIL,
  ON_ERROR_CREATE_REPLY_MAIL,
  ON_CREATE_REPLY_MAIL,ON_CREATE_REPLY_GMAIL,
  ON_START_CREATE_FORWARD_MAIL,
  ON_ERROR_CREATE_FORWARD_MAIL,
  ON_CREATE_FORWARD_MAIL,ON_CREATE_FORWARD_GMAIL,
  ON_CREATE_SIGNATURE_MAIL,
  ON_ERROR_CREATE_SIGNATURE_MAIL,
  ON_START_CREATE_SIGNATURE_MAIL,
  ON_UPDATE_SIGNATURE_MAIL,
  ON_ERROR_UPDATE_SIGNATURE_MAIL,
  ON_START_UPDATE_SIGNATURE_MAIL,
  ON_DELETE_SIGNATURE_MAIL,
  ON_ERROR_DELETE_SIGNATURE_MAIL,
  ON_START_DELETE_SIGNATURE_MAIL,
  ON_GET_SIGNATURE_MAIL,
  ON_ERROR_GET_SIGNATURE_MAIL,
  ON_START_GET_SIGNATURE_MAIL,
  ON_SET_DEFAULT_SIGNATURE_MAIL,
  ON_START_SET_DEFAULT_SIGNATURE_MAIL,
  ON_ERROR_SET_DEFAULT_SIGNATURE_MAIL,
  ON_FETCH_URVAL_MAIL,
  ON_ERROR_FETCH_URVAL_MAIL,
  ON_START_FETCH_URVAL_MAIL,
  ON_SET_CAMP_RECIPIENTS,
  FETCH_START_SET_UNAUTHE
}  from '../constants/ActionTypes'

import axios from 'util/Api' 
import { v4 as uuidv4 } from 'uuid';
import {history} from '../store'
import { isUndefined,isNull } from 'lodash';
import {RefreshUserInterface } from 'actions'
import { translate } from "../util/intlHelper";
import {encrypt,decrypt} from 'actions'
// router.get("/mail/get/all",UserController.getMinaoutlookMail)
export const createNewSignature = (Afid, Userid, Signature) => {
  const jwt =  JSON.parse(localStorage.token);

  return (dispatch) => { 
    dispatch({type: ON_START_CREATE_SIGNATURE_MAIL})
    axios.post('mail/signatures', {
      method: 'POST',
      body: encrypt(JSON.stringify({
       Afid, Userid, Signature
      })),
    },{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
     }).then( data => {
      console.log("createNewSignature: ", data);
      if( data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("createNewSignature1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_CREATE_SIGNATURE_MAIL, payload: ndate.results})
      }
      else{
        dispatch({type: ON_ERROR_CREATE_SIGNATURE_MAIL})
      }
     }).catch(function (error) {
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
        dispatch({type: ON_ERROR_CREATE_SIGNATURE_MAIL})
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
export const updateSignature = (Afid, Userid, Signature) => {
  const jwt =  JSON.parse(localStorage.token);

  return (dispatch) => { 
    dispatch({type: ON_START_UPDATE_SIGNATURE_MAIL})
    axios.put('mail/signatures', {
      method: 'PUT',
      body: encrypt(JSON.stringify({
       Afid, Userid, Signature
      }))},
      {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
     }).then( data => {
      console.log("updateSignature: ", data);
      if( data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("updateSignature1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_UPDATE_SIGNATURE_MAIL, payload: ndate.results})
      }
      else{
        dispatch({type: ON_ERROR_UPDATE_SIGNATURE_MAIL})
      }
       
     }).catch(function (error) {
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
        dispatch({type: ON_ERROR_UPDATE_SIGNATURE_MAIL})
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
export const deleteSignature = (Afid, Userid, SignatureId) => {
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => { 
    dispatch({type: ON_START_DELETE_SIGNATURE_MAIL})
    axios.delete('mail/signatures', {
      method: 'DELETE',
      params: encrypt(JSON.stringify({
       Afid, Userid, SignatureId
      })),
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
     }).then( data => {
      console.log("deleteSignature: ", data);
      if( data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("deleteSignature1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_DELETE_SIGNATURE_MAIL, payload: ndate.results})
      }
      else{
        dispatch({type: ON_ERROR_DELETE_SIGNATURE_MAIL})
      }
     }).catch(function (error) {
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
        dispatch({type: ON_ERROR_DELETE_SIGNATURE_MAIL})
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
export const setDefaultSignature = (Afid, Userid, SignatureId, SDefault) => {
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => { 
    dispatch({type: ON_START_SET_DEFAULT_SIGNATURE_MAIL})
    axios.put('mail/signatures/default', {
      method: 'PUT',
      body: encrypt(JSON.stringify({
       Afid, Userid, SignatureId, SDefault
      }))},
      {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
     }).then( data => {
      console.log("setDefaultSignature: ", data);
      if( data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("setDefaultSignature1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_SET_DEFAULT_SIGNATURE_MAIL, payload: ndate.results})
      }
      else{
        dispatch({type: ON_ERROR_SET_DEFAULT_SIGNATURE_MAIL})
      }
       
     }).catch(function (error) {
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
        dispatch({type: ON_ERROR_SET_DEFAULT_SIGNATURE_MAIL})
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
export const getSignatures = (Afid, Userid, AuthUserid, callback) => {
  const jwt =  JSON.parse(localStorage.token);

  return (dispatch) => { 
    dispatch({type: ON_START_GET_SIGNATURE_MAIL})
    axios.get('mail/signatures', {
      method: 'GET',
      params: encrypt(JSON.stringify({
       Afid, Userid
      })),
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
     }).then( data => {
      console.log("getSignatures: ", data);
      if( data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getSignatures1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_GET_SIGNATURE_MAIL, payload: ndate.results})
       if(callback) callback(ndate.results)
      }
      else{
        dispatch({type: ON_ERROR_GET_SIGNATURE_MAIL})
      }
       
       dispatch(RefreshUserInterface(AuthUserid))
     }).catch(function (error) {
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
        dispatch({type: ON_ERROR_GET_SIGNATURE_MAIL})
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}



export const deleteMails = (Afid, userid, emailId) => {
  const jwt =  JSON.parse(localStorage.token);

  return (dispatch) => {
    dispatch({type: ON_START_DELETE_MAILS})
    axios.delete('mail/delete', {
     method: 'DELETE',
     params: encrypt(JSON.stringify({
      Afid, userid, emailId:JSON.stringify(emailId)
     })),
     headers: {
         'content-type': 'application/json',
         'Authorization':   `Bearer ${jwt}`
     }       
    }).then( data  => {
     console.log("deleteMails: ", data);
     if( data.data.success){
      let endata = decrypt(data.data.encryptedData,data.data.iv)
      console.log("deleteMails1: ", endata);
      let ndate = JSON.parse(endata)
      dispatch({type: ON_DELETE_MAILS, payload: ndate.results})
     }
     else{
      dispatch({type: ON_ERROR_DELETE_MAILS})
     }
   
    }).catch(function (error) {
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       dispatch({type: ON_ERROR_DELETE_MAILS})
      if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      } 
    });
  }
}
export const moveMails = (Afid, userid, emailId, destinationId) => {
  const jwt =  JSON.parse(localStorage.token);

  return (dispatch) => {
    dispatch({type: ON_START_MOVE_MAILS})
    axios.post('mail/move', {
     method: 'POST',
     body: encrypt(JSON.stringify({
      Afid, userid, emailId, destinationId
     }))
    },{
     headers: {
         'content-type': 'application/json',
         'Authorization':   `Bearer ${jwt}`
     }       
    }).then( data  => {
     console.log("moveMails: ", data);
     if( data.data.success){ 
      let endata = decrypt(data.data.encryptedData,data.data.iv)
      console.log("moveMails1: ", endata);
      let ndate = JSON.parse(endata)
      dispatch({type: ON_MOVE_MAILS, payload: ndate.results})
      }
     else{
      dispatch({type: ON_ERROR_MOVE_MAILS})
     }
  
    }).catch(function (error) {
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       dispatch({type: ON_ERROR_MOVE_MAILS})
      if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      } 
    });
  }
}
//createGMailForward
export const createGMailForward = ( Afid, userid, ForwardId) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_CREATE_FORWARD_MAIL});
     axios.post('Gmail/createForward', 
     {
      method: 'POST',
      body: encrypt(JSON.stringify({
        userid: userid,
        Afid: Afid,
        ForwardId: ForwardId,
      }))
    },{
      headers: {
        'content-type': 'application/json',
        'Authorization':   `Bearer ${jwt}`
      }       
  }).then( data => {
      console.log("createGMailForward: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("createGMailForward: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_CREATE_FORWARD_GMAIL, payload: ndate.results});
      }else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("createGMailForward: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_CREATE_FORWARD_MAIL, payload: ndate.error});
      }
      
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CREATE_FORWARD_MAIL, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//
export const createMailForward = ( Afid, userid, ForwardId) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_CREATE_FORWARD_MAIL});
     axios.post('mail/createForward', 
     {
      method: 'POST',
      body: encrypt(JSON.stringify({
        userid: userid,
        Afid: Afid,
        ForwardId: ForwardId,
      }))
    },{
      headers: {
        'content-type': 'application/json',
        'Authorization':   `Bearer ${jwt}`
      }       
  }).then( data  => {
      console.log("saveMail: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("createMailForward: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_CREATE_FORWARD_MAIL, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("createMailForward: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_CREATE_FORWARD_MAIL, payload: ndate.error});
      }
      
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CREATE_FORWARD_MAIL, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//createGMailReply
export const createGMailReply = ( Afid, userid, ReplyId) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_CREATE_REPLY_MAIL});
     axios.post('Gmail/createReply', 
     {
      method: 'POST',
      body: encrypt(JSON.stringify({
        userid: userid,
        Afid: Afid,
        ReplyId: ReplyId,
      }))
    },{
      headers: {
        'content-type': 'application/json',
        'Authorization':   `Bearer ${jwt}`
      }       
  }).then( data => {
      console.log("saveMail: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("createGMailReply: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_CREATE_REPLY_GMAIL, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("createGMailReply: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_CREATE_REPLY_MAIL, payload: ndate.error});
      }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CREATE_REPLY_MAIL, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
// 
export const createMailReply = ( Afid, userid, ReplyId) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_CREATE_REPLY_MAIL});
     axios.post('mail/createReply', 
     {
      method: 'POST',
      body: encrypt(JSON.stringify({
        userid: userid,
        Afid: Afid,
        ReplyId: ReplyId,
      }))
    },{
      headers: {
        'content-type': 'application/json',
        'Authorization':   `Bearer ${jwt}`
      }       
  }).then( data => {
      console.log("saveMail: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("createMailReply: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_CREATE_REPLY_MAIL, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("createMailReply: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_CREATE_REPLY_MAIL, payload: ndate.error});
      }
       
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CREATE_REPLY_MAIL, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//saveGMail
export const saveGMail = ( Afid, userid, newMail) =>{
  const jwt =  JSON.parse(localStorage.token);
  const formData = new FormData()
   return (dispatch) => {
     dispatch({type: ON_START_SAVE_MAIL});

     formData.append('files[]', newMail.files)
     formData.append('userid', userid)
     formData.append('Afid', Afid)
     formData.append('id', newMail.id)
     formData.append('DraftId', newMail.DraftId)
     formData.append('ReplyId', newMail.ReplyId)
     formData.append('InReplyTo', newMail.InReplyTo)
     formData.append('References', newMail.References)
     formData.append('body', newMail.body)
     formData.append('subject', newMail.subject)
     formData.append('toRecipients', JSON.stringify(newMail.toRecipients))
     formData.append('ccRecipients', JSON.stringify(newMail.ccRecipients))
     formData.append('bccRecipients', JSON.stringify(newMail.bccRecipients))
     console.log(newMail)
     newMail.files.forEach(file => formData.append('files[]', file));

     axios.post('Gmail/new', 
     formData,
     {
      method: 'POST',
      body: {
        userid: userid,
        Afid: Afid,
        id: newMail.id,
        DraftId: newMail.DraftId,
        ReplyId: newMail.ReplyId,
        body: newMail.body,
        subject: newMail.subject,
        toRecipients: JSON.stringify(newMail.toRecipients),
        ccRecipients: JSON.stringify(newMail.ccRecipients),
        bccRecipients: JSON.stringify(newMail.bccRecipients),
      },
      headers: {
          'content-type': 'multipart/form-data',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("saveMail: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_SAVE_GMAIL, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_SAVE_MAIL, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SAVE_MAIL, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//
export const saveMail = ( Afid, userid, newMail) =>{
  const jwt =  JSON.parse(localStorage.token);
  const formData = new FormData()
   return (dispatch) => {
     dispatch({type: ON_START_SAVE_MAIL});
    
     formData.append('files[]', newMail.files)
     formData.append('userid', userid)
     formData.append('Afid', Afid)
     formData.append('id', newMail.id)
     formData.append('ReplyId', newMail.ReplyId)
     formData.append('body', newMail.body)
     formData.append('subject', newMail.subject)
     formData.append('toRecipients', JSON.stringify(newMail.toRecipients))
     formData.append('ccRecipients', JSON.stringify(newMail.ccRecipients))
     formData.append('bccRecipients', JSON.stringify(newMail.bccRecipients))
     console.log(newMail)
     newMail.files.forEach(file => formData.append('files[]', file));

     axios.post('mail/new', 
     formData,
     {
      method: 'POST',
      body: {
        userid: userid,
        Afid: Afid,
        id: newMail.id,
        ReplyId: newMail.ReplyId,
        body: newMail.body,
        subject: newMail.subject,
        toRecipients: JSON.stringify(newMail.toRecipients),
        ccRecipients: JSON.stringify(newMail.ccRecipients),
        bccRecipients: JSON.stringify(newMail.bccRecipients),
      },
      headers: {
          'content-type': 'multipart/form-data',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("saveMail: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_SAVE_MAIL, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_SAVE_MAIL, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SAVE_MAIL, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
export const sendMailAsNew = ( Afid, userid, newMail) =>{
  const jwt =  JSON.parse(localStorage.token);
  const formData = new FormData()
   return (dispatch) => {
      dispatch({type: ON_START_SEND_MAIL_AS_NEW});
      
      formData.append('userid', userid)
      formData.append('Afid', Afid)
      formData.append('id', newMail.id)
      formData.append('body', newMail.body)
      formData.append('subject', newMail.subject)
      formData.append('toRecipients', JSON.stringify(newMail.toRecipients))
      formData.append('ccRecipients', JSON.stringify(newMail.ccRecipients))
      formData.append('bccRecipients', JSON.stringify(newMail.bccRecipients))
      newMail.files.forEach(file => formData.append('files[]', file));
      axios.post('mail/sendAsNew', 
      formData,
     {
      method: 'POST',
      body: {
        userid: userid,
        Afid: Afid,
        id: newMail.id,
        body: newMail.body,
        subject: newMail.subject,
        toRecipients: JSON.stringify(newMail.toRecipients),
        ccRecipients: JSON.stringify(newMail.ccRecipients),
        bccRecipients: JSON.stringify(newMail.bccRecipients),
      },
      headers: {
          'content-type': 'multipart/form-data',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("sendMailAsNew: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_SEND_MAIL_AS_NEW, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_SEND_MAIL_AS_NEW, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SEND_MAIL_AS_NEW, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//deleteDraftGMail
export const deleteDraftGMail = ( Afid, userid, draftId) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_DELETE_MAILS})
    axios.delete('Gmail/draft/delete', {
      method: 'DELETE',
      params: encrypt(JSON.stringify({
       Afid, userid, draftId:draftId
      })),
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
     }).then( data => {
      console.log("deleteMails: ", data);
      if( data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("deleteDraftGMail: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_DELETE_DRAFT_GMAILS, payload: ndate.results})
      }
      else{
        dispatch({type: ON_ERROR_DELETE_MAILS})
      }
     }).catch(function (error) {
          if(!isUndefined(error.response)){
         if (error.response.status === 401) {
           dispatch({type: FETCH_START_SET_UNAUTHE});
          } 
        } 
        dispatch({type: ON_ERROR_DELETE_MAILS})
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//
export const sendGMailAsNew = ( Afid, userid, newMail) =>{
  const jwt =  JSON.parse(localStorage.token);
  const formData = new FormData()
   return (dispatch) => {
      dispatch({type: ON_START_SEND_MAIL_AS_NEW});
      
      formData.append('userid', userid)
      formData.append('Afid', Afid)
      formData.append('id', newMail.id)
      formData.append('DraftId', newMail.DraftId)
      formData.append('References', newMail.References)
      formData.append('InReplyTo', newMail.InReplyTo)
      formData.append('body', newMail.body)
      formData.append('subject', newMail.subject)
      formData.append('toRecipients', JSON.stringify(newMail.toRecipients))
      formData.append('ccRecipients', JSON.stringify(newMail.ccRecipients))
      formData.append('bccRecipients', JSON.stringify(newMail.bccRecipients))
      newMail.files.forEach(file => formData.append('files[]', file));
      axios.post('Gmail/sendAsNew', 
      formData,
     {
      method: 'POST',
      body: {
        userid: userid,
        Afid: Afid,
        id: newMail.id,
        DraftId: newMail.DraftId,
        InReplyTo: newMail.InReplyTo,
        References: newMail.References,
        body: newMail.body,
        subject: newMail.subject,
        toRecipients: JSON.stringify(newMail.toRecipients),
        ccRecipients: JSON.stringify(newMail.ccRecipients),
        bccRecipients: JSON.stringify(newMail.bccRecipients),
      },
      headers: {
          'content-type': 'multipart/form-data',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("sendMailAsNew: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_SEND_GMAIL_AS_NEW, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_SEND_MAIL_AS_NEW, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SEND_MAIL_AS_NEW, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }

export const getMail = (Afid,userid, emailId) =>{
const jwt =  JSON.parse(localStorage.token);
return (dispatch) => {
  dispatch({type: ON_START_GET_MAIL});
  axios.get('mail/get',
    { 
      params:encrypt(JSON.stringify({ userid,Afid, emailId })), 
      headers: { 'Authorization': `Bearer ${jwt}`} 
    }      
   ).then( data => {
    console.log("getMail: ", data);
    if(data.data.success){
      let endata = decrypt(data.data.encryptedData,data.data.iv)
      console.log("getMail1: ", endata);
      let ndate = JSON.parse(endata)
      dispatch({type: ON_GET_MAIL, payload: ndate.results});
    }
    else{
      let Data = isUndefined(data.data.error)?data.data:data.data.error
      let endata = decrypt(Data.encryptedData,Data.iv)
      console.log("getMail: ", endata);
      let ndate = JSON.parse(endata)
      dispatch({type: ON_ERROR_GET_MAIL, payload: ndate.error});
    }
     dispatch(RefreshUserInterface(userid))
   })
   .catch(function (error) {
     dispatch({type: ON_ERROR_GET_MAIL, payload: error.message});
     console.log("Error****:", error.message);
   });
  }
}
export const getGMail = (Afid,userid, emailId) =>{
const jwt =  JSON.parse(localStorage.token);
return (dispatch) => {
  dispatch({type: ON_START_GET_MAIL});
  axios.get('Gmail/get',
    { 
      params:encrypt(JSON.stringify({userid,Afid, emailId})), 
      headers: { 'Authorization': `Bearer ${jwt}`} 
    }      
   ).then( data  => {
    console.log("getGMail: ", data);
    if(data.data.success){
      let endata = decrypt(data.data.encryptedData,data.data.iv)
      console.log("getGMail1: ", endata);
      let ndate = JSON.parse(endata)
      dispatch({type: ON_GET_GMAIL, payload: ndate.results});
    }
    else{
      let Data = isUndefined(data.data.error)?data.data:data.data.error
      let endata = decrypt(Data.encryptedData,Data.iv)
      console.log("getGMail: ", endata);
      let ndate = JSON.parse(endata)
      dispatch({type: ON_ERROR_GET_MAIL, payload: ndate.error});
    }
     
     dispatch(RefreshUserInterface(userid))
   })
   .catch(function (error) {
     dispatch({type: ON_ERROR_GET_MAIL, payload: error.message});
     console.log("Error****:", error.message);
   });
  }
}
export const getGMailDraft = (Afid,userid, emailId,DraftId) =>{
const jwt =  JSON.parse(localStorage.token);
return (dispatch) => {
  dispatch({type: ON_START_GET_MAIL});
  axios.get('Gmail/draft/get',
    { 
      params:encrypt(JSON.stringify({ userid,Afid, emailId,DraftId } )), 
      headers: { 'Authorization': `Bearer ${jwt}`} 
    }      
   ).then( data => {
    console.log("getGMail: ", data);
    if(data.data.success){
      let endata = decrypt(data.data.encryptedData,data.data.iv)
      console.log("getGMail1: ", endata);
      let ndate = JSON.parse(endata)
      dispatch({type: ON_GET_GMAIL, payload: ndate.results});
    }
    else{
      let Data = isUndefined(data.data.error)?data.data:data.data.error
      let endata = decrypt(Data.encryptedData,Data.iv)
      console.log("getGMail: ", endata);
      let ndate = JSON.parse(endata)
      dispatch({type: ON_ERROR_GET_MAIL, payload: ndate.error});
    }
  
     dispatch(RefreshUserInterface(userid))
   })
   .catch(function (error) {
     dispatch({type: ON_ERROR_GET_MAIL, payload: error.message});
     console.log("Error****:", error.message);
   });
  }
}

export const getMailList = (Afid,userid, Buffer = 0, Skip, Top, FolderId, nextUrl, Search) =>{
const jwt =  JSON.parse(localStorage.token);
return (dispatch) => {
  dispatch({type: ON_START_GET_MAIL_LIST, payload: {Buffer}});
  axios.get('mail/get/all',
    { 
      params:encrypt(JSON.stringify({ userid,Afid, Skip, Top, FolderId, nextUrl, Search})), 
      headers: { 'Authorization': `Bearer ${jwt}`} 
    }      
   ).then( data => {
    console.log("getAllMail: ", data);
    if(data.data.success){
      let endata = decrypt(data.data.encryptedData,data.data.iv)
      console.log("getAllMail1: ", endata);
      let ndate = JSON.parse(endata)
      dispatch({type: ON_GET_MAIL_LIST, payload: {...ndate.results, Buffer}});
    }
    else{
      let Data = isUndefined(data.data.error)?data.data:data.data.error
      let endata = decrypt(Data.encryptedData,Data.iv)
      console.log("getAllMail: ", endata);
      let ndate = JSON.parse(endata)
      dispatch({type: ON_ERROR_GET_MAIL_LIST, payload: ndate.error});
    }
     dispatch(RefreshUserInterface(userid))
   })
   .catch(function (error) {
     dispatch({type: ON_ERROR_GET_MAIL_LIST, payload: error.message});
     console.log("Error****:", error.message);
   });
  }
}
export const getGMailList = (Afid,userid, Buffer = 0, Skip, Top, FolderId, nextUrl, Search) =>{
const jwt =  JSON.parse(localStorage.token);
return (dispatch) => {
  dispatch({type: ON_START_GET_MAIL_LIST, payload: {Buffer}});
  axios.get('Gmail/get/all',
    { 
      params:encrypt(JSON.stringify({ userid,Afid, Skip, Top, FolderId, nextUrl, Search })), 
      headers: { 'Authorization': `Bearer ${jwt}`} 
    }      
   ).then( data => {
    console.log("getAllMail: ", data);
    if(data.data.success){
      let endata = decrypt(data.data.encryptedData,data.data.iv)
      console.log("getAllMail1: ", endata);
      let ndate = JSON.parse(endata)
      dispatch({type: ON_GET_GMAIL_LIST, payload: {...ndate.results, Buffer}});
    }
    else{
      let Data = isUndefined(data.data.error)?data.data:data.data.error
      let endata = decrypt(Data.encryptedData,Data.iv)
      console.log("getAllMail: ", endata);
      let ndate = JSON.parse(endata)
      dispatch({type: ON_ERROR_GET_MAIL_LIST, payload: ndate.error});
    }
     dispatch(RefreshUserInterface(userid))
   })
   .catch(function (error) {
     dispatch({type: ON_ERROR_GET_MAIL_LIST, payload: error.message});
     console.log("Error****:", error.message);
   });
  }
}

export const getGFolderList = (Afid,userid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_GET_MAIL_FOLDERS});
    axios.get('Gmail/folder/get',
      { 
        params:encrypt(JSON.stringify({ userid,Afid})), 
        headers: { 'Authorization': `Bearer ${jwt}`} 
      }      
     ).then( data  => {
      console.log("getAllMail: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getGFolderList: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_GET_GMAIL_FOLDERS, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getGFolderList: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_GET_MAIL_FOLDERS, payload: ndate.error});
      }
       
     })
     .catch(function (error) {
       dispatch({type: ON_ERROR_GET_MAIL_FOLDERS, payload: error.message});
       console.log("Error****:", error.message);
     });
    }
  }

export const getFolderList = (Afid,userid) =>{
const jwt =  JSON.parse(localStorage.token);
return (dispatch) => {
  dispatch({type: ON_START_GET_MAIL_FOLDERS});
  axios.get('mail/folder/get',
    { 
      params:encrypt(JSON.stringify({userid,Afid})), 
      headers: { 'Authorization': `Bearer ${jwt}`} 
    }      
   ).then( data => {
    console.log("getAllMail: ", data);
    if(data.data.success){
      let endata = decrypt(data.data.encryptedData,data.data.iv)
      console.log("getFolderList: ", endata);
      let ndate = JSON.parse(endata)
      dispatch({type: ON_GET_MAIL_FOLDERS, payload: ndate.results});
    }
    else{
      let Data = isUndefined(data.data.error)?data.data:data.data.error
      let endata = decrypt(Data.encryptedData,Data.iv)
      console.log("getFolderList: ", endata);
      let ndate = JSON.parse(endata)
      dispatch({type: ON_ERROR_GET_MAIL_FOLDERS, payload: ndate.error});
    }
   })
   .catch(function (error) {
     dispatch({type: ON_ERROR_GET_MAIL_FOLDERS, payload: error.message});
     console.log("Error****:", error.message);
   });
  }
}
export const fetchUrvalMail = (Afid,userid,Filterstate,Campid = 0) =>{
const jwt =  JSON.parse(localStorage.token);
return (dispatch) => {
  dispatch({type: ON_START_FETCH_URVAL_MAIL});
  axios.get('mail/urval/fetch',
    { 
      params:encrypt(JSON.stringify({ userid,Afid,Filterstate,Campid })), 
      headers: { 'Authorization': `Bearer ${jwt}`} 
    }      
   ).then( data => {
    console.log("getAllMail: ", data);
    if(data.data.success){
      let endata = decrypt(data.data.encryptedData,data.data.iv)
      console.log("fetchUrvalMail: ", endata);
      let ndate = JSON.parse(endata)
      dispatch({type: ON_FETCH_URVAL_MAIL, payload: ndate.results});
      if(Campid !== 0) dispatch({type: ON_SET_CAMP_RECIPIENTS, payload: ndate.results})
    }
    else{
      let Data = isUndefined(data.data.error)?data.data:data.data.error
      let endata = decrypt(Data.encryptedData,Data.iv)
      console.log("fetchUrvalMail: ", endata);
      let ndate = JSON.parse(endata)
      dispatch({type: ON_ERROR_FETCH_URVAL_MAIL, payload: ndate.error});
    }
     
   })
   .catch(function (error) {
     dispatch({type: ON_ERROR_FETCH_URVAL_MAIL, payload: error.message});
     console.log("Error****:", error.message);
   });
  }
}

export const postSignatureImage = ( file,userid,Afid  ) =>{
  const jwt =  JSON.parse(localStorage.token);
  const formData = new FormData()
   return (dispatch) => {
      
    formData.append('userid', userid)
    formData.append('Afid', Afid)
    formData.append('files[]', file)

    return axios.post('mail/uploadSignatureImage', 
      formData,
      {
        method: 'POST',
        body: {
          userid: userid,
          Afid: Afid,
        },
        headers: {
            'content-type': 'multipart/form-data',
            'Authorization':   `Bearer ${jwt}`
        }       
     }).then(({data}) => {
      console.log("postSignatureImage: ", data);
      return data.url
      
     }).catch(function (error) {
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
        return ''
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //attachGMailToKund
 export const attachGMailToKund = (Afid, Userid, Mail, Orgnr) => {
  const jwt =  JSON.parse(localStorage.token);

  return (dispatch) => { 
    dispatch({type: ON_START_ATTACH_MAIL_TO_KUND})
    axios.post('Gmail/attachMailToKund', {
      method: 'POST',
      body: {
       Afid, Userid, Mail, Orgnr
      }
    },{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
     }).then(({data}) => {
      console.log("attachMailToKund: ", data);
       if (data.results) {
         dispatch({type: ON_ATTACH_GMAIL_TO_KUND, payload: data.results})
       } else {
         dispatch({type: ON_ERROR_ATTACH_MAIL_TO_KUND})
       }
     }).catch(function (error) {
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
        dispatch({type: ON_ERROR_ATTACH_MAIL_TO_KUND})
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
 //
 export const attachMailToKund = (Afid, Userid, Mail, Orgnr) => {
  const jwt =  JSON.parse(localStorage.token);

  return (dispatch) => { 
    dispatch({type: ON_START_ATTACH_MAIL_TO_KUND})
    axios.post('mail/attachMailToKund', {
      method: 'POST',
      body: encrypt(JSON.stringify({
       Afid, Userid, Mail, Orgnr
      }))
    },{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
     }).then( data => {
      console.log("attachMailToKund: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("attachMailToKund1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ATTACH_MAIL_TO_KUND, payload: ndate.results})
      }
      else{
        dispatch({type: ON_ERROR_ATTACH_MAIL_TO_KUND})
      }
     
     }).catch(function (error) {
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
        dispatch({type: ON_ERROR_ATTACH_MAIL_TO_KUND})
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}

